var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"error-page"},[_c('b-row',[_c('b-col',[_c('h1',{staticClass:"pb-3"},[_c('span',[_vm._v("404")]),_vm._v(" Page Not Found ")]),_c('b-button',{attrs:{"to":"/","variant":"rounded"}},[_vm._v(" Home ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }